
import React from 'react';
import { CalendarIcon } from './icons/CalendarIcon';
import { useTranslation } from '../i18n/LanguageContext';

const WHATSAPP_BUSINESS_LINK = "https://wa.me/message/TINGCS2EHASRK1";

interface WhatsAppButtonProps {
  text?: string;
  className?: string;
  iconSize?: string;
  ariaLabel?: string;
  IconComponent?: React.FC<React.SVGProps<SVGSVGElement>>;
  customHref?: string;
  message?: string;
}

export const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  text,
  className = "",
  iconSize = "w-5 h-5",
  ariaLabel,
  IconComponent = CalendarIcon,
  customHref,
  message,
}) => {
  const { t } = useTranslation();
  const buttonText = text || t('whatsapp.defaultText');

  const defaultStyles = "inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-brand-primary transition-all duration-300 ease-in-out button-glow";
  
  // Verifica se já existe uma classe de background definida no className recebido
  const hasBgDefined = className.includes('bg-') || className.includes('from-');
  const conditionalBg = hasBgDefined ? '' : 'bg-gradient-to-r from-gradient-start to-gradient-end hover:brightness-110';

  let href = customHref || WHATSAPP_BUSINESS_LINK;
  if (message && !customHref) {
    href = `https://wa.me/5531994875631?text=${encodeURIComponent(message)}`;
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${defaultStyles} ${conditionalBg} ${className}`}
      aria-label={ariaLabel || buttonText}
    >
      <IconComponent
        className={`inline-block mr-2 ${iconSize} align-middle`} 
        aria-hidden="true" 
      />
      {buttonText}
    </a>
  );
};
